import React, { useState, useMemo } from "react";
import Moment from "moment";
import { map, uniqBy } from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// Components
import Screen from "@Components/Screen";
import Table from "./Table";

// Utils
import dataHandler from "@Utils/dataHandler";

// Importamos el nuevo modal de la carpeta de Reports
import FilterModal from "./Modals/FilterModal";
import { reportOptionsBySection } from "./Modals/FilterModal/staticData";

const Reports = ({ dispatch, userName, companyName, channels }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	// Modal states
	const [platformfilters, setPlatformfilters] = useState([]);
	const [groupsfilters, setGroupsfilters] = useState([]);
	const [tagsSelected, setTagsSelected] = useState([]);
	const [categoriesSelected, setCategoriesSelected] = useState([]);
	const [startDate, setStartDate] = useState(Moment().format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState(Moment().format("YYYY-MM-DD"));
	const [contacts, setContacts] = useState("");
	const [agents, setAgents] = useState([]);
	const [note, setNote] = useState("");
	const [checkAlllData, setCheckAllData] = useState([]);
	const [dateField, setDateField] = useState("closeDate");
	const [channelFilters, setChannelFilters] = useState([]);
	const [stateValue, setStateValue] = useState("");
	const [conditionValue, setConditionValue] = useState([]);
	const [orderBy, setOrderBy] = useState("");
	const [orderDirection, setOrderDirection] = useState("");
	const [tabValue, setTabValue] = useState("");
	const [actionsSelected, setActionsSelected] = useState([]);
	const [groupBy, setGroupBy] = useState("");
	const [section, setSection] = useState("");

	// UI states
	const [showTable, setShowTable] = useState(false);
	const [tableValue, setTableValue] = useState({});
	const [seletedFilteres, setSeletedFilteres] = useState("");
	const [appliedFilters, setAppliedFilters] = useState({});

	// Opciones base para empezar a hacer genérico
	const options = section ? reportOptionsBySection[section] : Object.values(reportOptionsBySection).flat();

	const selectedOpt = options.find((o) => {
		return o.value === seletedFilteres;
	});
	let currentUrl = selectedOpt?.route || "chats";
	if (selectedOpt?.conditionalRoutes && conditionValue && selectedOpt.conditionalRoutes[conditionValue]) {
		currentUrl = selectedOpt.conditionalRoutes[conditionValue];
	}

	if (seletedFilteres === "Hora") {
		if (appliedFilters.groupBy === "groupId") {
			currentUrl = "/reports/times/groups";
		} else if (appliedFilters.groupBy === "userId") {
			currentUrl = "/reports/times/users";
		} else {
			currentUrl = "/reports/times/hours";
		}
	}

	const platforms = useMemo(() => {
		return uniqBy(
			map(channels, (item) => {
				return item.platform;
			}),
			"name"
		);
	}, [channels]);

	const handlerData = async (params, printable, findAll, isCheck = false) => {
		const mergedParams = { page: 1, rows: 20, ...appliedFilters, ...params };
		const data = await dataHandler({ dispatch, url: currentUrl, params: mergedParams });
		if (!isCheck && !printable) {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setTableValue(data.items);
		}
		if (printable) {
			setFilteredPrintData(data.items);
		}
		if (findAll) {
			setCheckAllData(data.items);
		} else {
			setCheckAllData([]);
		}
	};

	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				setTableValue(item);
				break;
			default:
				break;
		}
	};

	const handleApplyFilters = (filters) => {
		setShowTable(true);
		setAppliedFilters(filters);
		setActionsSelected(filters["action[]?"] || []);
	};

	React.useEffect(() => {
		if (showTable) {
			handlerData({});
		}
	}, [currentUrl, appliedFilters]);

	return (
		<Screen hasHeader hasSidebar headerTitle={`Reportes Unificados${seletedFilteres ? ` - ${seletedFilteres}` : ""}`}>
			<FilterModal
				companyName={companyName}
				userName={userName}
				tableValue={tableValue}
				agents={agents}
				contacts={contacts}
				startDate={startDate}
				endDate={endDate}
				note={note}
				platformfilters={platformfilters}
				groupsfilters={groupsfilters}
				tagsSelected={tagsSelected}
				categoriesSelected={categoriesSelected}
				setAgents={setAgents}
				setContacts={setContacts}
				setStartDate={setStartDate}
				setEndDate={setEndDate}
				setNote={setNote}
				setPlatformfilters={setPlatformfilters}
				setGroupsfilters={setGroupsfilters}
				setTagsSelected={setTagsSelected}
				setCategoriesSelected={setCategoriesSelected}
				seletedFilteres={seletedFilteres}
				options={options}
				setSeletedFilteres={setSeletedFilteres}
				dateField={dateField}
				setDateField={setDateField}
				onApplyFilters={handleApplyFilters}
				platforms={platforms}
				channelFilters={channelFilters}
				setChannelFilters={setChannelFilters}
				tabValue={tabValue}
				setTabValue={setTabValue}
				stateValue={stateValue}
				setStateValue={setStateValue}
				conditionValue={conditionValue}
				setConditionValue={setConditionValue}
				orderBy={orderBy}
				setOrderBy={setOrderBy}
				orderDirection={orderDirection}
				setOrderDirection={setOrderDirection}
				actionsSelected={actionsSelected}
				setActionsSelected={setActionsSelected}
				groupBy={groupBy}
				setGroupBy={setGroupBy}
				section={section}
				setSection={setSection}
				showTable={showTable}
				onEditFilters={() => {
					return setShowTable(false);
				}}
				onCancelFilters={() => {
					return setShowTable(true);
				}}>
				<Table
					filteredItems={filteredItems}
					handleButtom={handleButtom}
					filteredCount={filteredCount}
					handlerData={handlerData}
					filteredPrintData={filteredPrintData}
					checkAlllData={checkAlllData}
					route={currentUrl}
				/>
			</FilterModal>
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		channels: company.channels,
	};
}

Reports.propTypes = {
	dispatch: PropTypes.func,
	userName: PropTypes.string,
	companyName: PropTypes.string,
	channels: PropTypes.array,
};

export default connect(mapStateToProps)(Reports);
